import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Check if credentials are configured
const isConfigured = supabaseUrl && supabaseAnonKey;

if (!isConfigured) {
  console.warn(
    '⚠️ Supabase not configured. Please create a .env file with:\n' +
    'REACT_APP_SUPABASE_URL=your-supabase-url\n' +
    'REACT_APP_SUPABASE_ANON_KEY=your-anon-key\n\n' +
    'Get these from: https://supabase.com/dashboard/project/_/settings/api'
  );
}

// Create client only if configured, otherwise create a mock
export const supabase = isConfigured 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export const isSupabaseConfigured = isConfigured;

export default supabase;
